/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerVertical } from './';
import {
    FreelancerVerticalFromJSON,
    FreelancerVerticalFromJSONTyped,
    FreelancerVerticalToJSON,
} from './';
import type { FreelancerVerticalApplicationStatus } from './';
import {
    FreelancerVerticalApplicationStatusFromJSON,
    FreelancerVerticalApplicationStatusFromJSONTyped,
    FreelancerVerticalApplicationStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerVerticalStateInner
 */
export interface FreelancerVerticalStateInner {
    /**
     * 
     * @type {FreelancerVertical}
     * @memberof FreelancerVerticalStateInner
     */
    freelancerVertical: FreelancerVertical;
    /**
     * 
     * @type {FreelancerVerticalApplicationStatus}
     * @memberof FreelancerVerticalStateInner
     */
    freelancerVerticalApplicationStatus: FreelancerVerticalApplicationStatus;
}

/**
 * Check if a given object implements the FreelancerVerticalStateInner interface.
 */
export function instanceOfFreelancerVerticalStateInner(value: object): value is FreelancerVerticalStateInner {
    if (!('freelancerVertical' in value) || value['freelancerVertical'] === undefined) return false;
    if (!('freelancerVerticalApplicationStatus' in value) || value['freelancerVerticalApplicationStatus'] === undefined) return false;
    return true;
}

export function FreelancerVerticalStateInnerFromJSON(json: any): FreelancerVerticalStateInner {
    return FreelancerVerticalStateInnerFromJSONTyped(json, false);
}

export function FreelancerVerticalStateInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerVerticalStateInner {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancerVertical': FreelancerVerticalFromJSON(json['freelancerVertical']),
        'freelancerVerticalApplicationStatus': FreelancerVerticalApplicationStatusFromJSON(json['freelancerVerticalApplicationStatus']),
    };
}

export function FreelancerVerticalStateInnerToJSON(value?: FreelancerVerticalStateInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancerVertical': FreelancerVerticalToJSON(value['freelancerVertical']),
        'freelancerVerticalApplicationStatus': FreelancerVerticalApplicationStatusToJSON(value['freelancerVerticalApplicationStatus']),
    };
}

